import React from "react";
import { Alert } from "antd";

const SupportNumber = () => {
  const supportNumber = process.env.REACT_APP_SUPPORT_NUMBER;

  if (!supportNumber || supportNumber.trim().length === 0) return null;

  return (
    <div style={{ maxWidth: 350, marginTop: 20 }}>
      <Alert
        message="Support Number"
        description={`If you need any help, please contact us on this number +91${supportNumber}`}
        type="info"
        showIcon
      />
    </div>
  );
};

export default SupportNumber;
